import React from 'react';

import { toast } from "react-toastify";

const options = {
  position     : toast.POSITION.BOTTOM_CENTER,
  closeOnClick : true,
  theme        : "colored",
};

export default {
  general: (msg, opt={})=> {
    toast.success(msg, {...options, ...opt});
  },

  profileUpdated: (msg)=> {
    toast.success("Profile Updated", options);
   },

  contactUs: (msg)=> {
    toast.success(msg, options);
  },

  copy: (what)=> {
    toast.success(`${what} copied`, options);
  },

  emptyCode: (msg)=> {
    toast.error(msg, options);
  },

  error: (msg)=> {
    toast.error(msg, options);
  },

}

